import { store } from '@/store'
import { useGetUserRoleQuery, userRoleApi } from '@/store/services'
import { toOptions } from '@/utils'
import { useTranslation } from 'react-i18next'
import { createSearchParams } from 'react-router-dom'
import { SelectWrapper } from '../wrapper'
import { AsyncPaginate } from 'react-select-async-paginate'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

export const UserRoleSelector = ({ onChange, value, required = false }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})

  const loadOptions = async (search, _loadedOptions, { page }) => {
    const searchParams = createSearchParams({ page, per_page: 10 })

    if (search) {
      searchParams.set('q', search)
    }

    const { roles, meta } = await store.dispatch(
      userRoleApi.endpoints.getUserRoles.initiate(`?${searchParams.toString()}`)
    ).unwrap()

    const options = toOptions({ data: roles, label: 'nameText' }).sort((a, b) => a.label.localeCompare(b.label))
    console.log(options)
    const hasMore = page < meta.pagination.total_pages

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  const handleChange = (option) => {
    setSelectedOption(option)
    onChange(option)
  }

  const getCurrentRole = async (id) => {
    const { role = {} } = await store.dispatch(
      userRoleApi.endpoints.getUserRole.initiate(id)
    ).unwrap()

    setSelectedOption(toOptions({ data: [role], label: 'nameText' })[0])
  }

  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }
    if (value === selectedOption?.value) return

    getCurrentRole(value)
  }, [value])

  return (
    <SelectWrapper label={t('userRole.one')} required={required}>
      {
        (styles) => (
          <AsyncPaginate
            isClearable
            value={!selectedOption?.value ? null : selectedOption}
            debounceTimeout={600}
            placeholder={t('select.one')}
            loadingMessage={() => t('select.loading')}
            onChange={handleChange}
            loadOptions={loadOptions}
            styles={styles}
            menuPortalTarget={document.body}
            additional={{
              page: 1
            }}
          />
        )
      }
    </SelectWrapper >
  )
}

UserRoleSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number
}
